import { useState, useEffect } from "react";
import { Header } from "../components/portal/Header";
import { Hero, DemoCredentialModal } from "../components/portal/Hero";
import { StakeholderGrid } from "../components/portal/StakeholderGrid";
import { PodArchitecture } from "../components/portal/PodArchitecture";
import { SubscriptionTiers } from "../components/portal/SubscriptionTiers";
import { Footer } from "../components/portal/Footer";
import { AboutModal } from "../components/portal/AboutModal";
import { AuthModal } from "../components/portal/AuthModal";
import { IntakeModal } from "../components/portal/IntakeModal";

export default function Landing() {
  const [aboutOpen, setAboutOpen] = useState(false);
  const [authOpen, setAuthOpen] = useState(false);
  const [demoOpen, setDemoOpen] = useState(false);
  const [intakeTrack, setIntakeTrack] = useState(null);

  useEffect(() => {
    const t = new URLSearchParams(window.location.search).get("intake");
    if (t) {
      setIntakeTrack(t);
      window.history.replaceState({}, "", "/");
    }
  }, []);

  return (
    <div data-testid="landing-page">
      <Header onOpenAbout={() => setAboutOpen(true)} onOpenAuth={() => setAuthOpen(true)} onOpenDemo={() => setDemoOpen(true)} />
      <Hero onOpenAuth={() => setAuthOpen(true)} onOpenDemo={() => setDemoOpen(true)} onApplyPreceptor={() => setIntakeTrack("preceptors")} />
      <StakeholderGrid onOpenAuth={() => setAuthOpen(true)} onOpenDemo={() => setDemoOpen(true)} onApplyPreceptor={() => setIntakeTrack("preceptors")} onApplyTrack={(trackId) => setIntakeTrack(trackId)} />
      <PodArchitecture />
      <SubscriptionTiers />
      <Footer onOpenAbout={() => setAboutOpen(true)} />
      <AboutModal open={aboutOpen} onClose={() => setAboutOpen(false)} />
      <AuthModal open={authOpen} onClose={() => setAuthOpen(false)} />
      <DemoCredentialModal open={demoOpen} onClose={() => setDemoOpen(false)} />
      <IntakeModal open={!!intakeTrack} onClose={() => setIntakeTrack(null)} trackId={intakeTrack || "preceptors"} />
    </div>
  );
}
